export default "__VITE_ASSET__DhrjybLG__"